// extracted by mini-css-extract-plugin
module.exports = {"chef_house":"SakeItem_chef_house__D4SCK","SakeItem":"SakeItem_SakeItem__JPiOb","title":"SakeItem_title__2mIK2","selected":"SakeItem_selected__3qIlM"};